/**
 * Lokale Sicht auf gemeinsamen Status: Serverstand + noch nicht hochgeladene
 * Aktionen aus der Warteschlange (optimistische Anzeige). Reine Funktionen.
 */
import type { QueuedAction } from './actions.js';
import type { PutoutDTO } from '../shared/types.js';
import { expectedEnd, isActive, runPhase, type RunDTO } from '../shared/appliances.js';

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}

export function overlayPutouts(server: PutoutDTO[], queued: QueuedAction[], me: { id: number; name: string }): PutoutDTO[] {
  let list = server.map((p) => ({ ...p }));
  for (const a of queued) {
    if (a.type === 'waste.putout') {
      const key = String(a.payload.eventKey);
      if (!list.some((p) => p.eventKey === key)) {
        list.push({ id: a.id, eventKey: key, userId: me.id, userName: firstName(me.name), at: a.at, pending: true });
      }
    } else if (a.type === 'waste.undo') {
      list = list.filter((p) => p.id !== a.payload.putoutId);
    }
  }
  return list;
}

/**
 * Geräte-Status mit noch nicht hochgeladenen Aktionen (Start, Verlängern,
 * Abbrechen, Ausgeräumt) überlagern – spiegelt die Server-Logik vereinfacht.
 */
export function overlayRuns(server: RunDTO[], queued: QueuedAction[], me: { id: number; name: string }): RunDTO[] {
  let runs = server.map((r) => ({ ...r }));
  for (const a of queued) {
    const p = a.payload;
    if (a.type === 'appliance.start') {
      const applianceId = Number(p.applianceId);
      const current = runs.find((r) => r.applianceId === applianceId && isActive(r));
      if (current && runPhase(current, a.at) === 'laeuft') continue; // Server lehnt ab bzw. übernimmt
      runs = runs.filter((r) => r !== current);
      runs.push({
        id: a.id, applianceId, source: 'manual', startedBy: me.id, startedByName: firstName(me.name), startedAt: a.at,
        plannedMinutes: Number(p.minutes), extendedMinutes: 0, status: 'running', finishedAt: null, finishedSource: null,
        sensorConfirmedAt: null, emptiedBy: null, emptiedByName: null, emptiedAt: null, cancelledBy: null, cancelledByName: null,
        cancelledAt: null, cancelReason: '', pending: true,
      });
    } else if (a.type === 'appliance.extend') {
      const r = runs.find((x) => x.id === p.runId);
      if (!r || r.finishedSource === 'sensor') continue;
      const newEnd = Math.max(expectedEnd(r), a.at) + Number(p.minutes) * 60_000;
      r.extendedMinutes = Math.round((newEnd - r.startedAt) / 60_000) - r.plannedMinutes;
      r.pending = true;
    } else if (a.type === 'appliance.cancel' || a.type === 'appliance.done') {
      runs = runs.filter((x) => x.id !== p.runId);
    }
  }
  return runs;
}
